import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const ArrowForwardIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M16.175 13H4V11H16.175L10.575 5.4L12 4L20 12L12 20L10.575 18.6L16.175 13Z" />
  </Icon>
)
